import enableExpandableTextContent from '../page-details/enableExpandableTextContent';
import offerActions from './actions';

export const initOfferStateModals = () => {
  offerActions();

  enableExpandableTextContent({
    expandLink: {
      selector: '.offer-description-expander a',
    },
    content: {
      selector: '.offer-description-content',
      expandedClass: 'offer-description-content-expanded',
    },
    section: {
      selector: '.offer-description',
    },
  });
};
